import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "configurator";
  defaultLang = "ua";

  constructor(private translate: TranslateService) {
    // 1. Зчитуємо атрибут lang з тегу <html> (наприклад: "uk", "en", "ru")
    const htmlLang = document.documentElement.getAttribute("lang");

    // Опціонально: якщо на сайті випадково виведеться "uk-UA" або "en-US",
    // беремо перші 2 літери, щоб точно збігалося з назвами файлів перекладу
    const formattedHtmlLang = htmlLang ? htmlLang.split("-")[0].toLowerCase() : null;

    // 2. Встановлюємо пріоритет мови:
    // Спочатку дивимось на тег <html>, якщо його немає — в LocalStorage, якщо й там порожньо — беремо дефолт
    let lang = formattedHtmlLang || localStorage.getItem("dafault_lang") || this.defaultLang;

    // Якщо визначена мова 'uk', примусово перемикаємо додаток на префікс 'ua'
    if (lang === "uk") {
      lang = "ua";
    }

    // 3. Активуємо переклад в Angular
    this.translate.setDefaultLang(this.defaultLang);
    this.translate.use(lang);

    // 4. Синхронізуємо локальне сховище (записуємо туди вже валідний префікс 'ua')
    localStorage.setItem("dafault_lang", lang);
  }
}
